<template>
  <v-container id="user-list">
    <v-row>
      <v-col>Usuários do Sistema</v-col>
      <v-col class="text-right">
        <v-btn outlined color="primary" class="ml-3" :to="'/usuario/novo'">
          Novo Usuário
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Nome do usuário"
          name="nome"
          type="text"
          required
          v-model="filter.nome"
          clearable
        ></v-text-field>
      </v-col>

      <v-col>
        <app-city-combobox :filter="filter"></app-city-combobox>
      </v-col>

      <v-col>
        <app-group-combobox
          :filter="filter"
          :idsToFilter="groupsHierarquia"
        ></app-group-combobox>
      </v-col>

      <v-col>
        <app-axis-combobox :filter="filter"></app-axis-combobox>
      </v-col>

      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="listUsers()">
          <span>Filtrar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="usuariosHabilitados"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.nome="{ item }">
            <a
              :href="'./#/usuario/editar/' + item.usuarioId"
              v-if="!isAnalista || item.grupoId === 2"
              >{{ item.nome }}</a
            >
            <span v-else>{{ item.nome }}</span>
          </template>
          <template v-slot:item.acoes="{ item }">
            <modal-confirm-block-user
              v-if="
                isFullAdmin ||
                (config.desabilitarUsuario && groupsConfig.desabilitarUsuario)
              "
              :usuario="item"
              @onCloseModal="listUsers"
            ></modal-confirm-block-user>
          </template>

          <template slot="no-data">
            <span> Nenhum usuário retornado </span>
          </template>
        </v-data-table>
        <template
          v-if="
            isFullAdmin ||
            (config.visualizarUsuarioDesabilitado &&
              groupsConfig.visualizarUsuarioDesabilitado)
          "
        >
          <hr style="margin: 2rem 0" />

          <h4>Usuários Desabilitados</h4>
          <v-data-table
            :headers="headers"
            :items="usuariosDesabilitados"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.nome="{ item }">
              <a
                :href="'./#/usuario/editar/' + item.usuarioId"
                v-if="!isAnalista || item.grupoId === 2"
                >{{ item.nome }}</a
              >
              <span v-else>{{ item.nome }}</span>
            </template>
            <template v-slot:item.acoes="{ item }">
              <modal-confirm-recover-user
                v-if="
                  isFullAdmin ||
                  (config.desabilitarUsuario && groupsConfig.desabilitarUsuario)
                "
                :usuario="item"
                @onCloseModal="listUsers"
              ></modal-confirm-recover-user>
            </template>

            <template slot="no-data">
              <span> Nenhum usuário retornado </span>
            </template>
          </v-data-table>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { userAPI } from "./UserAPI";
import { groupsAPI } from "@/modules/groups";

import { mapGetters, mapActions } from "vuex";
import { AppCityCombobox } from "@/modules/city";
import { AppGroupCombobox } from "@/modules/user";
import { AppAxisCombobox } from "@/modules/axis";
import ModalConfirmBlockUser from "./ModalConfirmBlockUser.vue";
import ModalConfirmRecoverUser from "./ModalConfirmRecoverUser.vue";

export default {
  components: {
    AppCityCombobox,
    AppGroupCombobox,
    AppAxisCombobox,
    ModalConfirmBlockUser,
    ModalConfirmRecoverUser,
  },
  computed: {
    ...mapGetters(["user", "isAnalista", "isFullAdmin"]),
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "nome" },
        { text: "CPF", value: "cpf" },
        { text: "E-mail", value: "email" },
        { text: "Grupo", value: "grupo.nome" },
        { text: "Ações", value: "acoes" },
      ],
      usuarios: [],
      usuariosHabilitados: [],
      usuariosDesabilitados: [],
      groupsHierarquia: [],
      filter: {},
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    listUsers() {
      this.setLoading(true);

      userAPI
        .getByFilter(this.filter)
        .then((resp) => {
          this.usuarios = resp.data;
          this.getHierarquia(this.user.grupoId);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter usuários");
        });
    },
    getHierarquia(groupId) {
      groupsAPI
        .getOne(groupId)
        .then((resp) => {
          const { hierarquia } = resp.data;
          this.groupsHierarquia = (hierarquia && JSON.parse(hierarquia)) || [];
          if (!this.isFullAdmin) {
            this.usuarios = this.usuarios.filter((user) =>
              this.groupsHierarquia.some(
                (hie) => hie.usuarioGrupoId === user.grupoId
              )
            );

            this.usuarios = this.usuarios.filter(
              (user) => user.email !== "admin@admin.com.br"
            );
          }

          this.usuariosHabilitados = this.usuarios.filter(
            (item) => item.habilitado
          );
          this.usuariosDesabilitados = this.usuarios.filter(
            (item) => !item.habilitado
          );

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao achar hierarquia usuário");
        });
    },
  },
  async mounted() {
    this.listUsers();
  },
};
</script>
